import Actions from './actions'
import Reducer from './reducer'

export default {
  Reducer,
  Actions,
}
